import React, { useState, useEffect } from 'react'
import { FileUploader } from "react-drag-drop-files";

export const FileDropPad = ({ startFileAdd, maxSize }) => {

    return (
      <FileUploader maxSize={maxSize ?? 20} onSelect={(file) => {startFileAdd(file); }} onDrop={(file) => {startFileAdd(file); }}  name="file" multiple={true} />
    );
}
